import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COLLECTIONS, slug } from "../data/site";
import { Reveal } from "./motion";

export const Collections = () => (
  <section id="collections" data-testid="collections-section" className="mx-auto max-w-[1600px] px-6 py-28 md:px-12 md:py-40">
    <Reveal>
      <div className="flex justify-end">
        <Link
          to="/shop"
          data-testid="collections-browse-all-btn"
          className="group flex items-center gap-3 rounded-full border border-navy px-7 py-3.5 text-xs font-medium uppercase tracking-[0.25em] text-navy transition-transform duration-300 hover:scale-95"
        >
          Browse all products
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </Link>
      </div>
    </Reveal>

    <div className="mt-16 grid gap-5 md:grid-cols-12 md:mt-20">
      {COLLECTIONS.map((c, i) => (
        <Reveal key={c.name} delay={Math.min(i * 0.06, 0.3)} className={c.span}>
          <Link
            to={`/collections/${c.slug}`}
            data-testid={`collection-card-${slug(c.name)}`}
            className={`group flex h-full flex-col justify-between border border-navy/20 p-8 transition-transform duration-500 hover:-translate-y-2 md:p-10 ${c.bg}`}
          >
            <div className="flex items-start justify-between">
              <span className="font-playfair text-sm italic text-navy/50">No. {String(i + 1).padStart(2, "0")}</span>
              <ArrowUpRight className="h-6 w-6 text-navy/40 transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-navy" />
            </div>
            <div className="mt-16 md:mt-24">
              <h3 className="font-playfair text-3xl leading-tight tracking-tight text-navy md:text-4xl">{c.name}</h3>
              <p className="mt-4 text-[11px] uppercase leading-relaxed tracking-[0.2em] text-navy/50">{c.pieces}</p>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
